import { Injectable } from '@angular/core';
import OlMap from 'ol/Map';

import { isValidCoordinate, lonLatToRdCoordinate } from '../map/observer-map.helpers';
import { DetectedDroneViewModel } from '../models/detected-drone.model';
import { ObserverPositionDto } from '../models/observer-position-dto';

@Injectable({
  providedIn: 'root',
})
export class ObserverMapViewportService {
  private map: OlMap | null = null;

  setMap(map: OlMap): void {
    this.map = map;
  }

  clearMap(map: OlMap): void {
    if (this.map === map) {
      this.map = null;
    }
  }

  updateSize(delayMs = 180): void {
    setTimeout(() => this.map?.updateSize(), delayMs);
  }

  zoomToObserver(observer: ObserverPositionDto): void {
    if (!isValidCoordinate(observer.longitude, observer.latitude)) {
      return;
    }

    this.zoomToLonLat(observer.longitude, observer.latitude);
  }

  zoomToDrone(drone: DetectedDroneViewModel): void {
    this.zoomToLonLat(drone.longitude, drone.latitude);
  }

  private zoomToLonLat(longitude: number, latitude: number): void {
    if (!this.map || !isValidCoordinate(longitude, latitude)) {
      return;
    }

    const view = this.map.getView();
    const currentZoom = view.getZoom() ?? 14;

    view.animate({
      center: lonLatToRdCoordinate([longitude, latitude]),
      zoom: Math.max(currentZoom, 17),
      duration: 320,
    });
  }
}
